import logo from "./logo.svg";
import "./App.css";
import React, { useLayoutEffect, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
} from "react-router-dom";
import HeroSection from "./components/HeroSection/HeroSection";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import theme from "./theme";
import Curve from "./Curve";
import Home from "./pages/Home/Home";
import ActiveRouteHandler from "./components/ActiveRouteHandler/ActiveRouteHandler";
import About from "./pages/About/About";
import Workshop from "./pages/Workshop/Workshop";
import Grants from "./pages/Grants/Grants";
import HubResources from "./pages/HubResources/HubResources";
import DH from "./pages/DH/DH";
import WorkshopSchedule from "./pages/WorkshopSchedule/WorkshopSchedule";
import AuthProvider from "./components/Context/AuthContext";
import Signup from "./pages/SignUp/Signup";
import Login from "./pages/LogIn/Login";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import ProtectedRoute from "./components/Context/ProtectedRoute";
import TranscriptionBox from "./components/TranscriptionBox/TranscriptionBox";
import Transcription from "./pages/Transcription/Transcription";
import TranscriptionPageViewer from "./pages/TranscriptionPageViewer/TranscriptionPageViewer";
import PageEditor from "./pages/PageEditor/PageEditor";
import DocumentsList from "./pages/DocumentList/DocumentList";
import CategorizedDocuments from "./pages/CategorizedDocuments/CategorizedDocuments";
import Application from "./pages/Application/Application";
import MdhhTools from "./pages/MdhhTools/MdhhTools";
import Policies from "./pages/Policies/Policies";
import ContactUS from "./pages/ContactUS/ContactUS";
import { motion } from "framer-motion";
import { LoadingProvider } from "./components/LoadingContext/LoadingContext";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Resetpassword from "./pages/ResetPassword/ResetPassword";
import TranscriptionInstructions from "./pages/TranscriptionInstructions/TranscriptionInstructions";
import ThreadsPage from "./pages/ThreadsPage/ThreadsPage";
import ThreadDetail from "./pages/ThreadDetail/ThreadDetail";
import EditProfile from "./pages/EditProfile/EditProfile";
import useInactivityTimer from "./components/UseInactivityTimer/useInactivityTimer";
import InactivityModal from "./components/InactivityModal/InactivityModal";
import Blogs from "./pages/Blogs/Blogs";
import { BlogForm } from "./pages/BlogForm/BlogForm";
import BlogDetails from "./pages/BlogDetails/BlogDetails";
import RequireAdmin from "./components/RequireAdmin/RequireAdmin";
import AdminViewUsers from "./pages/AdminViewUsers/AdminViewUsers";
import ResendVerification from "./pages/ResendVerification/ResendVerification";
import TranscriptionHome from "./pages/TranscriptionHome/TranscriptionHome";
import WorkshopAccess from "./pages/WorkshopAccess/WorkshopAccess";
import WorkshopMaterials from "./pages/WorkshopMaterials/WorkshopMaterials";
import { Alert } from "@mui/material";
import { useContext } from "react";
import { AuthContext } from "./components/Context/AuthContext";
import EditThread from "./pages/EditThread/EditThread";
import ChatWidgetPrototype from "./components/chatwidget/chatWidget";
import PdfTutorials from "./pages/Tutorials/PdfTutorials";
import GrantsDashboard from "./pages/Grants/GrantsDashboard";
import AdminGrantsOverview from "./pages/AdminGrantsOverview/AdminGrantsOverview";
import AboutSummerResidency from "./pages/AboutSummerResidency/AboutSummerResidency";
import AboutSummerResidency2026 from "./pages/SummerWorkshop2026/AboutSummerResidency2026";
import AboutSummerResidency2025 from "./pages/SummerWorkshop2025/AboutSummerWorkshop2025";
import SummerWorkshopArchive2025 from "./pages/SummerWorkshopArchive2025/SummerWorkshopArchive2025";
import SummerWorkshop2026Application from "./pages/SummerWorkshop2026/SummerWorkshop2026Application";
import TranscribeathonTestPanel from "./pages/TranscribeathonTestPanel/TranscribeathonTestPanel";
import TranscribeathonTestLeaderboard from "./pages/TranscribeathonTestLeaderboard/TranscribeathonTestLeaderboard";
import TranscribeathonAdminPanel from "./pages/TranscribeathonAdminPanel/TranscribeathonAdminPanel";
import TranscribeathonEventPage from "./pages/TranscribeathonEventPage/TranscribeathonEventPage";
import AdminContributionAnalytics from "./pages/AdminContributionAnalytics/AdminContributionAnalytics";
import WorkshopMaterialsSummer2026 from "./pages/WorkshopMaterialsSummer2026/WorkshopMaterialsSummer2026";
import ScheduleSummer2026 from "./pages/ScheduleSummer2026/ScheduleSummer2026";
import GuestThreadPage from "./pages/GuestThreadPage/GuestThreadPage";
import Participants2026 from "./pages/SummerWorkshop2026/Participants2026";
import MyActivity from "./pages/MyActivity/MyActivity";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GuestSpeakers from "./components/Speakers/Speakers2026";
import WeeklyReadings from "./pages/WorkshopMaterialsSummer2026/WorkshopMaterialsSummer2026";
import CallForPapers from "./pages/Conference/Conference";
import SummerResidency2026Archive from "./pages/SummerResidency2026Archive/SummerResidency2026Archive";
import SummerWorkshop2027Application from "./pages/SummerWorkshop2027/SummerWorkshop2027Application";
import AboutSummerResidency2027 from "./pages/SummerWorkshop2027/AboutSummerResidency2027";
function App() {
  return (
    <LoadingProvider>
      <AuthProvider>
        <Router>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppInner />
          </ThemeProvider>
        </Router>
      </AuthProvider>
    </LoadingProvider>
  );
}

function AppInner() {
  const [footerHeight, setFooterHeight] = useState(0);
  const footerRef = useRef(null);
  const [footerSectionHeight, setFooterSectionHeight] = useState("");
  const [activeMenu, setActiveMenu] = useState(
    localStorage.getItem("activeMenu")
  );
  const { warningVisible, inactiveMinutes, dismissWarning } =
    useInactivityTimer({ logoutTime: 15 * 60 * 1000 });

  useEffect(() => {
    localStorage.setItem("activeMenu", activeMenu);
  }, [activeMenu]);
  {
    /*   useEffect(()=>{
        const routeTitles={
          '/':'MS Digital Hub',
          '/about':'About - MS Digital Hub',
          '/workshop':'Workshop - MS Digital Hub',
          '/workshop-schedule':'Workshop Schedule - MS Digital Hub',
          '/grants':'Grants - MS Digital Hub',
          '/dh':'What are Digital Humanities? - MS Digital Hub',
          '/dh-hub':'Community Initiative - MS Digital Hub',
          '/transcription':'Transcription -  MS Digital Hub',
          '/FAQs':'FAQs - MS Digital Hub',
          '/application':'Summer Residency Application - MS Digital Hub',
          '/login':'LogIn - MS Digital Hub',
          '/sign-in':'SignIn - MS Digital Hub',
          '/signup':'SignUp - MS Digital Hub',
          '/mdhh-tools':'MDHH Tools - MS Digital Hub',
          '/policies':'Policies - MS Digital Hub',
          '/contact-us':'Contact US - MS Digital Hub',
          '/about-summer-residency-program': 'About Summer Residency Program - MS Digital Hub'


        };
        const title= routeTitles[location.pathname] || 'MS Digital Hub';
        document.title=title;
      },[location]);
*/
  }
  const { user } = useContext(AuthContext);
  const RequireWorkshop2026 = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (!user) return <Navigate to="/login" />;

    if (!user.workshopAccess2026) {
      return <Navigate to="/" />;
    }

    return children;
  };
  const [showLeaderboardBanner, setShowLeaderboardBanner] = useState(
    localStorage.getItem("leaderboardBanner") !== "hidden"
  );

  const closeLeaderboardBanner = () => {
    localStorage.setItem("leaderboardBanner", "hidden");
    setShowLeaderboardBanner(false);
  };
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "70vh" }}>
        {/*  {showLeaderboardBanner && (
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 9999,
              bgcolor: "#ffffff",
              borderBottom: "3px solid #C9A227",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <Box
              sx={{
                maxWidth: "1400px",
                mx: "auto",
                py: 1,
                px: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                component="a"
                href="https://www.ms-digital-hub.com/transcribeathon-events/6a5f18ca8566ec7f0556cb77"
                target="_blank"
                sx={{
                  textDecoration: "none",
                  color: "#222",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                }}
              >
                🏆 Transcribe-a-thon - Summer Residency 2026 - Session II
                Leaderboard is now live.
                <span
                  style={{
                    color: "#C9A227",
                    fontWeight: 700,
                    marginLeft: 6,
                  }}
                >
                  View Rankings →
                </span>
              </Typography>
            </Box>
          </Box> 
        )}*/}

        <Header
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          title={activeMenu}
        />
        <Curve fillColor="#ffd700" />
        <Box sx={{ flex: 1 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route
                path="/resend-verification"
                element={<ResendVerification />}
              />
              <Route path="/about" element={<About />} />
              <Route path="/workshop" element={<Workshop />} />
              <Route
                path="/summer-workshop-2025/workshop-schedule"
                element={<WorkshopSchedule />}
              />
              <Route
                path="/grants"
                element={<Grants deadline="2025-10-01T23:59:59" />}
              />
              <Route path="/dh" element={<DH />} />
              <Route path="/dh-hub" element={<HubResources />} />
              <Route
                path="/summerworkshop-2025-archive"
                element={<SummerWorkshopArchive2025 />}
              />{" "}
              <Route
                path="/summerworkshop-2026-archive"
                element={<SummerResidency2026Archive />}
              />
              <Route
                path="/summer-workshop-2025/FAQs"
                element={
                  <Application defaultTab={3} deadline="2025-04-15T23:59:59" />
                }
              />
              <Route
                path="/summer-workshop-2025/application"
                element={
                  <Application defaultTab={0} deadline="2025-04-15T23:59:59" />
                }
              />
              <Route
                path="/summer-workshop-2026/application"
                element={
                  <SummerWorkshop2026Application
                    defaultTab={0}
                    deadline="2026-04-02T23:59:59"
                  />
                }
              />{" "}
              <Route
                path="/summer-workshop-2027/application"
                element={<SummerWorkshop2027Application />}
              />
              <Route path="/login" element={<Login />} />
              <Route path="/sign-in" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/mdhh-tools" element={<MdhhTools />} />
              <Route path="/dh-tutorials" element={<PdfTutorials />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/contact-us" element={<ContactUS />} />
              <Route
                path="/about-summer-workshop-2025"
                element={<AboutSummerResidency2025 />}
              />
              <Route
                path="/about-summer-workshop-program"
                element={<AboutSummerResidency />}
              />
              <Route
                path="/about-summer-workshop-2026"
                element={<AboutSummerResidency2026 />}
              />
              <Route
                path="/about-summer-workshop-2027"
                element={<AboutSummerResidency2027 />}
              />
              <Route
                path="/get-started-transcription"
                element={<TranscriptionHome />}
              />
              <Route
                path="/summer-workshop-2026/guestSpeakers"
                element={<GuestSpeakers />}
              />
              <Route
                path="/summer-workshop-2026/participants"
                element={<Participants2026 />}
              />
              ;
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<Resetpassword />} />
              <Route
                path="/transcription-instructions"
                element={<TranscriptionInstructions />}
              />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:id" element={<BlogDetails />} />
              <Route path="/transcription" element={<Transcription />} />
              <Route
                path="/transcription/documents"
                element={<DocumentsList />}
              />
              <Route
                path="/transcription/documents/:documentId"
                element={<TranscriptionPageViewer />}
              />
              <Route
                path="/transcription/:category"
                element={<CategorizedDocuments />}
              />
              <Route
                path="/transcription/:category/:documentId"
                element={<TranscriptionPageViewer />}
              />
              <Route path="/conference" element={<CallForPapers />} />
              <Route path="/guest-thread/:id" element={<GuestThreadPage />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/blogs/create" element={<BlogForm />} />
                <Route path="/blogs/edit/:id" element={<BlogForm />} />
                <Route path="/dh-hub" element={<HubResources />} />
                <Route path="/Chat-Thread" element={<ThreadsPage />} />
                <Route path="/thread/edit/:id" element={<EditThread />} />
                <Route path="/thread/:id" element={<ThreadDetail />} />
                <Route
                  path="/transcription/:category/:documentId/pages"
                  element={<TranscriptionPageViewer />}
                />
                <Route
                  path="/document/:documentId/page/:pageNumber"
                  element={<PageEditor />}
                />
                <Route path="/edit-profile" element={<EditProfile />} />
                <Route
                  path="/Admin-View"
                  element={
                    <RequireAdmin>
                      <AdminViewUsers />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="/transcribeathon-admin"
                  element={
                    <RequireAdmin>
                      <TranscribeathonAdminPanel />
                    </RequireAdmin>
                  }
                />
                <Route path="/workshop-access" element={<WorkshopAccess />} />
                <Route
                  path="/summer-workshop-2025/workshop-materials"
                  element={<WorkshopMaterials />}
                />
                <Route path="/grants-dashboard" element={<GrantsDashboard />} />
                <Route
                  path="/transcription/my-activity"
                  element={<MyActivity />}
                />
              </Route>
              <Route
                path="/grants-overview"
                element={<AdminGrantsOverview />}
              />
              <Route
                path="/transcribeathon-events/:eventId"
                element={<TranscribeathonEventPage />}
              />
              <Route
                path="/admin/contribution-analytics"
                element={<AdminContributionAnalytics />}
              />
              <Route
                path="/summer-workshop-2026/workshop-materials"
                element={
                  <RequireWorkshop2026>
                    <WeeklyReadings />
                  </RequireWorkshop2026>
                }
              />
              <Route
                path="/summer-workshop-2026/workshop-schedule"
                element={
                  <RequireWorkshop2026>
                    <ScheduleSummer2026 />
                  </RequireWorkshop2026>
                }
              />
            </Routes>
          </motion.div>
        </Box>
      </Box>

      <InactivityModal
        open={warningVisible}
        onDismiss={dismissWarning}
        inactiveMinutes={inactiveMinutes}
      />

      <Footer />
      <ChatWidgetPrototype />
    </>
  );
}

export default App;
